import { Button, Link, Loading } from 'components'
import GroupErrorPage from 'components/Misc/GroupErrorPage/GroupErrorPage'
import { getGroupTabs, useGroup, useGroupMembers } from 'features/Group'
import GroupNotFound from 'features/Group/assets/group_not_found.svg'
import { AppPage } from 'interfaces'
import { useRouter } from 'next/router'
import React, { Fragment, useEffect, useState } from 'react'
import { useUser } from 'state'
import { useTimeout } from 'usehooks-ts'
import { logger } from 'utils'

import { Menu, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import { TokensIcon } from '@radix-ui/react-icons'
import { tx } from '@twind/core'

import checkToShowGroupPage from '../utils/checkToShowGroupPage'
import formatGroupName from '../utils/formatGroupName'

const GroupPage: AppPage = () => {
  const [showGroupsErrorPage, setShowGroupsErrorPage] = useState(false)
  const user = useUser()
  const router = useRouter()
  const { query } = router
  const { slug, tab } = query
  const groupSlug = typeof slug === 'string' ? slug : ''
  const tabName = typeof tab === 'string' ? tab || 'home' : 'home' // the `/` route should also open home tab
  // const [count, setCount] = useState<number>(0)

  const { data: groupDetails, isLoading: isGroupLoading } = useGroup(
    groupSlug,
    'v2=true'
  )

  const { data: groupMembers, isLoading: isGroupMembersLoading } =
    useGroupMembers(groupDetails && groupDetails.id)

  useEffect(() => {
    if (!user.discord_active) {
      setShowGroupsErrorPage(true)
      return
    }
    setShowGroupsErrorPage(false)
  }, [user.discord_active, user.type])

  logger('group', groupDetails, groupMembers)

  useTimeout(
    () => {
      if (!groupMembers || !groupDetails) {
        router.push('/groups')
      }
      // if (
      //   groupDetails &&
      //   user &&
      //   user.type !== 'admin' &&
      //   user.user_group_details &&
      //    user.user_group_details.length > 0 &&
      //   !isGroupSlugEqualToAnyUserGroup(groupSlug, user.user_group_details) &&
      //   user.id !== groupDetails.batch_leader_id
      // ) {
      //   router.push(`/groups/${user.user_group_details.groupSlug}`)
      // }
    },
    !groupMembers || !groupDetails
      ? //  ||
        // (groupDetails &&
        //   user &&
        //   user.type !== 'admin' &&
        //   user.user_group_details &&
        //   user.user_group_details.length > 0 &&
        //   !isGroupSlugEqualToAnyUserGroup(groupSlug, user.user_group_details) &&
        //   user.id !== groupDetails.batch_leader_id)
        4000
      : null
  )

  // useInterval(
  //   () => {
  //     setCount((prevState) => prevState + 1)
  //   },
  //   user.type !== 'admin' &&
  //     user.user_group_details &&
  //     user.user_group_details.length > 0 &&
  //     !isGroupSlugEqualToAnyUserGroup(groupSlug, user.user_group_details) &&
  //     groupDetails &&
  //     user.id !== groupDetails.batch_leader_id &&
  //     count < 4
  //     ? 1000
  //     : null
  // )

  if (isGroupLoading || isGroupMembersLoading) {
    return <Loading centerParent={true}></Loading>
  }

  if (!groupMembers || !groupDetails) {
    return (
      <div className="flex flex-col-reverse gap-6 md:flex-row items-center min-h-[90vh] justify-between px-4 py-10">
        <div className="flex flex-col lg:w-[60%] gap-10">
          <div className="text-3xl lg:text-4xl text-zinc-100">
            This group does not exist, We will redirect you to the groups page
            where you can choose to join an existing group or create a new one
          </div>
          <Link href={'/groups'}>
            <Button className="flex justify-center w-full items-center gap-2 border-2 w-max">
              Search Groups to Join
            </Button>
          </Link>
        </div>
        <div className="flex flex-col justify-center mt-10 md:mt-0 gap-4">
          <img src={GroupNotFound.src} alt="GroupNotFound" />
        </div>
      </div>
    )
  }

  if (
    user.type !== 'admin' &&
    user.user_group_details &&
    user.user_group_details.length > 0 &&
    !checkToShowGroupPage(groupSlug, user.user_group_details, groupDetails) &&
    user.id !== groupDetails.batch_leader_id
  ) {
    return (
      <div className="flex flex-col-reverse gap-6 md:flex-row items-center min-h-[90vh] justify-between px-4 py-10">
        <div className="flex flex-col lg:w-[60%] gap-10">
          <div className="leading-[3rem] text-3xl lg:text-4xl text-zinc-100">
            You are already part of these groups{' '}
          </div>
          {user.user_group_details.map((group) => (
            <div key={group.slug} className="flex flex-row items-center gap-3">
              <div className="font-semibold text-xl">
                &#x2022; {formatGroupName(group.name || ' ', 'frontend')}
              </div>
              <Link href={`/groups/${group.slug}`} className="w-full sm:w-max">
                <Button
                  size={'small'}
                  className="flex justify-center items-center gap-2 border-2 w-full sm:w-max">
                  Go to this group
                </Button>
              </Link>
            </div>
          ))}
        </div>
        <div className="flex flex-col justify-center mt-10 md:mt-0 gap-4">
          <img src={GroupNotFound.src} alt="GroupNotFound" />
        </div>
      </div>
    )
  }

  const groupTabs = getGroupTabs(
    user,
    groupMembers,
    user.id === groupDetails.batch_leader_id
  )
  const TabComponent = groupTabs[tabName] ? groupTabs[tabName].component : null

  return (
    <>
      {showGroupsErrorPage && <GroupErrorPage />}
      <div className="">
        <h1 className="sr-only"> Group </h1>
        <nav className="max-w-3xl w-full mx-auto lg:max-w-7xl pt-6">
          <div className="hidden sm:flex sm:space-x-4 px-2">
            {Object.values(groupTabs).map((item) => (
              <Link
                key={item.key}
                href={`/groups/${groupSlug}/${item.key}`}
                className={tx(
                  tabName === item.key
                    ? 'text-white bg-opacity-10'
                    : 'bg-opacity-0',
                  'text-sm font-medium rounded-md bg-white px-3 py-2 hover:bg-opacity-10'
                )}>
                {item.label}
              </Link>
            ))}
          </div>
          <Menu>
            {({ open }) => (
              <div className="sm:hidden flex relative mx-3 my-1">
                <Menu.Button className="flex gap-2 items-center bg-opacity-10 text-white px-3 py-2 rounded-md text-base font-medium transition-colors focus:outline-none focus:ring bg-zinc-500">
                  Tabs{' '}
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <TokensIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Menu.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95">
                  <Menu.Items className="z-20 flex flex-col gap-1 absolute -left-0 rounded-md shadow-lg bg-zinc-700 top-10 px-1 py-1">
                    {Object.values(groupTabs).map((item) => (
                      <Menu.Item key={item.key}>
                        <Link
                          href={`/groups/${groupSlug}/${item.key}`}
                          className={tx(
                            tabName === item.key
                              ? 'text-white bg-opacity-10'
                              : 'bg-opacity-0',
                            'font-medium rounded-md bg-white px-3 py-2 hover:bg-opacity-10 w-[60vw]'
                          )}>
                          {item.label}
                        </Link>
                      </Menu.Item>
                    ))}
                  </Menu.Items>
                </Transition>
              </div>
            )}
          </Menu>
        </nav>

        <main className="pb-8 max-w-3xl w-full mx-auto lg:max-w-7xl shadow pt-5">
          {TabComponent ? (
            <TabComponent
              groupDetails={groupDetails}
              groupMembers={groupMembers}
            />
          ) : (
            <>No tab</>
          )}
        </main>
      </div>
    </>
  )
}

GroupPage.auth = {
  shouldBeLoggedIn: true
}

GroupPage.layout = {
  navProps: {
    type: 'product'
  },
  hideFooter: true,
  hideSchoolNotification: true
}

GroupPage.seo = {
  title: 'Group | Devsnest'
}

export default GroupPage
